<template>
  <TemplateBase>
    <main class="relative z-0 col-span-full row-start-2">
      <!-- Breadcrumbs -->
      <!-- TODO: back-end fix breadcrumbs + mobile back link -->
      <OrganismNavigationBreadcrumb class="relative z-10 mx-auto pt-4 px-4 lg:pt-10 xl:container" :path="breadcrumbs" />

      <!-- Header -->
      <MoleculeHeaderAnimalHome
        class="header-margin relative -mt-12 lg:-mt-24"
        :title="domain === 'ikZoekBaas' ? t_('header-ikz') : t_('header-mdiz')"
        :subtitle="page.title"
        :image="page.image"
      />

      <section class="container relative z-10 grid-cols-12 mx-auto px-4 2xl:px-56 md:grid md:gap-x-8 md:mb-16 md:px-6 lg:px-8 xl:px-12">
        <MoleculeAnimalCategories
          translation-group="ikZoekBaas"
          :categories="domain === 'ikZoekBaas' ? page.availableCategories : page.foundCategories"
          :animal-counts="animalCounts"
          class="row-end-2 row-start-1 mb-10 md:col-span-full lg:mb-12"
        />
        <MoleculeHighlightedAnimals :animal-ids="domain === 'ikZoekBaas' ? page.availableAnimals : page.foundAnimals" :translation-group="domain" />
        <MoleculeShare
          class="mb-6 md:col-span-6 md:col-start-7 md:row-end-auto md:row-start-3 md:mb-0 xl:col-span-4"
          :title="$t('animal-shelter-share-title')"
          :text="$t('animal-shelter-share-text')"
          :url="page.url"
        />

        <MoleculeCardText :title="page.title" class="mb-8 p-6 overflow-hidden md:col-span-6 md:row-end-auto md:row-start-3 md:mb-0 xl:col-span-4 xl:col-start-1">
          <template v-if="page.department && page.department.address">
            <address class="mb-4 not-italic">
              {{ page.department.address.streetName }} {{ page.department.address.streetNumber }} {{ page.department.address.streetNumberAddition }}<br />
              {{ page.department.address.postalCode }} {{ page.department.address.city }}
            </address>
            <div v-if="page.department.telephone" class="prose prose--app mb-4 max-w-none" v-html="page.department.telephone" />
            <div v-if="page.department.visitingHours" class="prose prose--app mb-4 max-w-none" v-html="page.department.visitingHours" />
            <div class="flex flex-col items-start">
              <AtomLinkWithIcon v-if="page.department.email" class="mb-4" :url="page.department.email" :title="page.department.staticEmail">Mail ons</AtomLinkWithIcon>
              <AtomLinkWithIcon v-if="page.department.webPage" :url="page.department.webPage" :title="page.department.staticWebPage">Website</AtomLinkWithIcon>
            </div>
          </template>
        </MoleculeCardText>
      </section>
    </main>
  </TemplateBase>
</template>

<script setup lang="ts">
import { setupSiteConfig } from '~/composables/craft'
import { setupTranslationPrefixer } from '~/composables/util'

interface Props {
  page: {
    title: string
    image: any // Specify the correct type
    availableCategories?: any // Specify the correct type
    foundCategories?: any // Specify the correct type
    availableAnimals?: any // Specify the correct type
    foundAnimals?: any // Specify the correct type
    url: string
    department?: {
      address?: {
        streetName: string
        streetNumber: string
        streetNumberAddition: string
        postalCode: string
        city: string
      }
      telephone?: string
      visitingHours?: string
      email?: string
      staticEmail?: string
      webPage?: string
      staticWebPage?: string
    }
  }
  animalCounts: Record<string, number> | undefined
  breadcrumbs: Array<any> // Specify the correct type
}

defineProps<Props>()

// Setup functions
const { t_ } = setupTranslationPrefixer('shelter-detail')
const { domain } = setupSiteConfig()
</script>

<style lang="scss" scoped>
.header-margin {
  margin-bottom: -10vw;

  @screen md {
    margin-bottom: -17vw;
  }

  @screen lg {
    margin-bottom: -12vw;
  }

  @screen xl {
    margin-bottom: -20vw;
  }
}
</style>
